<mat-sidenav-container
  class="sidenav-container"
  [class.instant-action-sidenav]="!actionSidenavService.animate()"
>
  <mat-sidenav
    #sidenav
    class="sidenav"
    [fixedInViewport]="fixedInViewPort"
    [attr.role]="isHandset() ? 'dialog' : 'navigation'"
    [mode]="isHandset() ? 'over' : 'side'"
    [opened]="!isHandset()"
  >
    <div class="sidenav-inner">
      <div class="sidenav-nav-scroll">
        <app-nav-tree></app-nav-tree>
      </div>
    </div>
  </mat-sidenav>

  <mat-sidenav
    #actionSidenav
    class="action-sidenav"
    position="end"
    [mode]="isHandset() ? 'over' : 'side'"
    [opened]="actionSidenavService.isOpen()"
    (closed)="actionSidenavService.close()"
  >
    <jtms-action-sidenav />
  </mat-sidenav>

  <mat-sidenav-content class="sidenav-content">
    @if (loading()) {
      <mat-progress-bar
        color="accent"
        mode="indeterminate"
      ></mat-progress-bar>
    }

    @if (!actionSidenavService.isOpen() && actionSidenavService.portal()) {
      <button
        mat-icon-button
        class="show-side-panel-tab"
        (click)="actionSidenavService.toggle()"
        matTooltip="Show side panel"
        matTooltipPosition="left"
      >
        <mat-icon>chevron_left</mat-icon>
      </button>
    }

    <jtms-alert-header />
    <div
      class="main-content-wrapper"
      [class.left-open]="sidenav.opened"
      [class.right-open]="actionSidenav.opened"
    >
      <main class="main-content-frame">
        <router-outlet></router-outlet>
      </main>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
